export default __webpack_public_path__ + "static/media/placeholder_dummy2016-tattoo01-de.86e35e50.png";